export default "__VITE_ASSET__ce97616a__"